import {UIUtilsEjsVariables} from '../../../../../shared/scripts/UIUtilsEjsVariables'
import {UIWHeaderController} from '../../../ui_html/header/UIWHeaderController'
import {Scene} from '../../../ui_html/UISceneTypes'
import {UIWFooterController} from '../../../ui_html/UIWFooterController'
import {UIDAboutSceneController} from './UIDAboutSceneController'
import {UIDCareersSceneController} from './UIDCareersSceneController'
import {UIDCommunitySceneController} from './UIDCommunitySceneController'
import {UIDFAQSceneController} from './UIDFAQSceneController'
import {UIDGiftingSceneController} from './UIDGiftingSceneController'
import {UIDLeaderboardSceneController} from './UIDLeaderboardSceneController'
import {UIDPatchNotesSceneController} from './UIDPatchNotesSceneController'
import {UIDPrivacyPolicySceneController} from './UIDPrivacyPolicySceneController'
import {UIDStoreSceneController} from './UIDStoreSceneController'
import {UIDProfileSceneController} from './UIDProfileSceneController'
import {UIDValuesSceneController} from './UIDValuesSceneController'
import {UIDTermsSceneController} from './UIDTermsSceneController'
import {UIDPressKitSceneController} from './UIDPressKitSceneController'
import {UIDRefundPolicySceneController} from './UIDRefundPolicyController'
import {UIDReplaySceneController} from './UIDReplaySceneController'

export class UIDiscordSceneController {
    readonly discordLeaderboardController: UIDLeaderboardSceneController
    readonly discordStoreController: UIDStoreSceneController
    private readonly discordAboutController: UIDAboutSceneController
    private readonly discordCareersController: UIDCareersSceneController
    private readonly discordCommunityController: UIDCommunitySceneController
    private readonly discordFAQController: UIDFAQSceneController
    private readonly discordPrivacyPolicyController: UIDPrivacyPolicySceneController
    private readonly discordPatchNotesController: UIDPatchNotesSceneController
    readonly discordProfileController: UIDProfileSceneController
    private readonly discordGiftingController: UIDGiftingSceneController
    private readonly discordValuesController: UIDValuesSceneController
    private readonly discordTermsController: UIDTermsSceneController
    private readonly discordPressKitController: UIDPressKitSceneController
    private readonly discordRefundPolicyController: UIDRefundPolicySceneController
    readonly discordReplayController: UIDReplaySceneController

    constructor(header: UIWHeaderController, footer: UIWFooterController) {
        if(!UIUtilsEjsVariables.isUserOnDiscord) return

        this.discordLeaderboardController = new UIDLeaderboardSceneController(header)
        this.discordStoreController = new UIDStoreSceneController(header)
        this.discordAboutController = new UIDAboutSceneController(header, footer)
        this.discordCareersController = new UIDCareersSceneController(header, footer)
        this.discordCommunityController = new UIDCommunitySceneController(header, footer)
        this.discordFAQController = new UIDFAQSceneController(header, footer)
        this.discordPrivacyPolicyController = new UIDPrivacyPolicySceneController(header, footer)
        this.discordPatchNotesController = new UIDPatchNotesSceneController(header, footer)
        this.discordProfileController = new UIDProfileSceneController(header, footer)
        this.discordGiftingController = new UIDGiftingSceneController(header, footer)
        this.discordValuesController = new UIDValuesSceneController(header, footer)
        this.discordTermsController = new UIDTermsSceneController(header, footer)
        this.discordPressKitController = new UIDPressKitSceneController(header, footer)
        this.discordRefundPolicyController = new UIDRefundPolicySceneController(header, footer)
        this.discordReplayController = new UIDReplaySceneController()
    }

    showScene(scene: Scene) {
        if(!UIUtilsEjsVariables.isUserOnDiscord) return

        switch(scene) {
            case Scene.DiscordLeaderboard: void this.discordLeaderboardController.show(); break
            case Scene.DiscordStore: this.discordStoreController.show(); break
            case Scene.DiscordAbout: this.discordAboutController.show(); break
            case Scene.DiscordCareers: this.discordCareersController.show(); break
            case Scene.DiscordCommunity: this.discordCommunityController.show(); break
            case Scene.DiscordFAQ: this.discordFAQController.show(); break
            case Scene.DiscordPrivacyPolicy: this.discordPrivacyPolicyController.show(); break
            case Scene.DiscordPatchNotes: this.discordPatchNotesController.show(); break
            case Scene.DiscordProfile: this.discordProfileController.show(); break
            case Scene.DiscordGifting: this.discordGiftingController.show(); break
            case Scene.DiscordValues: this.discordValuesController.show(); break
            case Scene.DiscordTerms: this.discordTermsController.show(); break
            case Scene.DiscordPressKit: this.discordPressKitController.show(); break
            case Scene.DiscordRefundPolicy: this.discordRefundPolicyController.show(); break
            default: throw new Error('Invalid scene')
        }
    }

    hideAllScenes() {
        if(!UIUtilsEjsVariables.isUserOnDiscord) return

        this.discordLeaderboardController.hide()
        this.discordStoreController.hide()
        this.discordAboutController.hide()
        this.discordCareersController.hide()
        this.discordCommunityController.hide()
        this.discordFAQController.hide()
        this.discordPrivacyPolicyController.hide()
        this.discordPatchNotesController.hide()
        this.discordProfileController.hide()
        this.discordGiftingController.hide()
        this.discordValuesController.hide()
        this.discordTermsController.hide()
        this.discordPressKitController.hide()
        this.discordRefundPolicyController.hide()
    }
}
